import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import DS from 'ember-data';

export default class NoAccessibleWorkspacesRoute extends Route {
  @service auth!: AuthService;
  @service store!: DS.Store;

  beforeModel() {
    let { user } = this.auth;

    if (user?.defaultEnvironment) {
      this.router.transitionTo('environment', user.defaultEnvironment);
    }
  }

  async model() {
    let users = await this.store.findAll('user');
    return users.filter((user) => user.permissions['account/team_members/edit']);
  }
}
